import {Component, Input} from '@angular/core';
import {SceneryService} from '../../services/scenery.service';
import {Matm} from '../../classes/Matm';

@Component({
  selector: 'app-daylight-slider',
  templateUrl: './daylight-slider.component.html',
  styleUrls: ['./daylight-slider.component.scss']
})
export class DaylightSliderComponent {

  dayLight = 0;
  @Input() isOpen = false;
  @Input() active = false;
  min = 0;
  max = 9;
  gradient = 0;

  constructor(
    private env: SceneryService
  ) {
  }

  changeDayLight(value: number) {
    const interval = {
      min: this.min,
      max: this.max,
      value
    };
    this.dayLight = value;
    this.gradient = Matm.mapRange(interval, {min: 0, max: 1});
    this.env.setDayLight(interval);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/daylight-slider/daylight-slider.component.ts